import client from "/src/services/client";

export default {
    getAll: (params = {}) => client.get(`messaging/opt-outs`, params),
    // Posted rather than patched: the client exposes no patch.
    revoke: (id) => client.post(`messaging/opt-outs/${id}/revoke`, {}),
};
